import React, { useState, useEffect } from "react";
import { Modal } from "~/rs-components/global";
import CommentsForm from "./CommentsForm.client";
import { comments } from "../../../../setup/settings/__product";
import Star from "~/assets/icons/Start";

const Comments = ({ product, customer }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [showForm, setShowForm] = useState(false);
  const productHandle = product.handle;
  const gid = product.id;
  const shopifyId = product.id.split('/').pop();

  if (!comments.enabled) {

    return (
      <>
        <div className="reviewsProducts">
          <p className="loading">It is necessary to enable the configuration.</p>
        </div>
      </>)
  }

  const getReviews = async () => {
    try {
      const response = await fetch(`/externalapi/review/?shopifyId=${shopifyId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error fetching reviews: ${response.statusText}`);
      }

      const data = await response.json();
      setReviews(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getReviews();
  }, [productHandle]);

  const sortedReviews = [...reviews].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
  });

  const handleSortChange = (event) => {
    setSortOrder(event.target.value);
  };

  const openForm = () => setShowForm(true);
  const closeForm = () => setShowForm(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    if (customer != undefined) {
      setIsLoggedIn(true)
    }
  }, []);


  if (loading) {

    return (
      <>
        <div className="reviewsProducts">
          <p className="loading">Loading reviews...</p>
        </div>
      </>)
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  return (
    <>
      {!isLoggedIn ?
        <>
          <div className="reviewsProducts">
            <div className="btnLogin">
              <h2>{comments.titleWithoutReviews}</h2>
              <p>{comments.text}</p>
              <br />
              <button className="btn-login" onClick={() => (window.location.href = "/account/login")}>
                {comments.buttonTextLogin}
              </button>
            </div>
          </div>

        </>
        :
        <>

          {showForm && (
            <div className="reviewsProducts">
              <Modal close={closeForm}>
                <div className="userModal">
                  <CommentsForm shopifyId={shopifyId} handle={productHandle} close={closeForm} />
                </div>
              </Modal>
            </div>
          )}
          {sortedReviews?.length > 0 ?
            <div className="reviewsProducts">
              <div className="reviewsWrapper">

                <div className="leftRow">
                  <h1>{comments.title}</h1>
                  <div className="summaryStars">
                    <ReviewSummary reviews={reviews} />

                  </div>
                  <div className="btnWrite">
                    <button onClick={openForm}>
                      {showForm ? 'Cancel review' : comments.buttonText}
                    </button>
                  </div>

                </div>



                <div className="gridReviews">

                  <div className="shortBy">
                    <label htmlFor="sortOrder">
                      Sort reviews by:
                    </label>
                    <select id="sortOrder" value={sortOrder} onChange={handleSortChange}>
                      <option value="desc">Newest</option>
                      <option value="asc">Oldest</option>
                    </select>
                  </div>

                  <div className="fixCol">

                    {sortedReviews.map((review) => (
                      <div className="cardReviews" key={review.id}>

                        <div className="topArea">
                          <strong className="nameReviewer">{review.reviewer.name}</strong>

                          <div className="starDate">
                            <div className="star" >
                              <div>
                                {Array(review.rating)
                                  .fill(null)
                                  .map((_, index) => (
                                    <Star key={index} />
                                  ))}
                              </div>
                            </div>

                            <span className="dateReviews" >
                              {new Date(review.created_at).toLocaleDateString()}
                            </span>
                          </div>

                        </div>

                        <p className="reviewTitle">{review.title}</p>
                        <p className="reviewBody">{review.body}</p>
                        <div className="imgArea">
                          {review.pictures && review.pictures.length > 0 && (
                            <div>
                              <p>Images:</p>
                              {review.pictures.map((picture, index) => (
                                <img
                                  key={index}
                                  src={picture.urls.huge}
                                  alt={`Review Image ${index + 1}`} />
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                    <div className="fake-scroll"></div>
                  </div>
                </div>

              </div>

            </div>
            :
            <div className="reviewsProducts">
              <div className="btnLogin">
                <h2>{comments.titleWithoutReviews}</h2>
                <p>{comments.text}</p>
                <br />
                <div className="btnWrite">
                  <button onClick={openForm}>
                    {showForm ? 'Cancel review' : comments.buttonText}
                  </button>
                </div>
              </div>
            </div>
          }

        </>

      }
    </>


  );
};

export default Comments;


const ReviewSummary = ({ reviews }) => {
  if (reviews.length === 0) return null;

  const totalReviews = reviews.length;
  const averageRating = totalReviews > 0
    ? (reviews.reduce((sum, r) => sum + r.rating, 0) / totalReviews).toFixed(1)
    : "0.0";

  const starDistribution = [0, 0, 0, 0, 0];
  reviews.forEach(review => starDistribution[5 - review.rating]++);

  return (
    <div className="reviewSummary">
      <div className="averageRating">
        <span className="ratingNumber">{averageRating}</span>
        <div className="stars">
          {Array.from({ length: 5 }, (_, i) => (
            <Star key={i} />
          ))}
        </div>
        <p>{totalReviews} calificaciones</p>
      </div>

      <div className="starDistribution">
        {starDistribution.map((count, index) => (
          <div key={index} className="starRow">
            <span>{5 - index}  <Star key={index} /></span>
            <div className="bar">
              <div
                className="fill"
                style={{ width: `${(count / totalReviews) * 100}%` }}
              ></div>
            </div>
            <span>{count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};